import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

const useClearWidget = (id: string) => {
  const {
    widgets: { clear }
  } = useDispatch<Dispatch>();

  const clearWidget = useCallback(() => {
    clear({ id });
  }, [clear, id]);

  useEffect(() => clearWidget, [clearWidget]);

  return clearWidget;
};

export default useClearWidget;
